import { StateType } from 'data/types'

export const get = (state: StateType) => state.auth.settings.data

export const isFetching = (state: StateType) => state.auth.settings.fetching
